/* --------------------------------------------------------------------------
    Topic Image Fade-In (Intersection Observer Version)
-------------------------------------------------------------------------- */
"use strict";
import 'fastdom';
var $ = jQuery;

function initImageFadeIn() {
    // Select all fade-in image wrappers
    var $wrappers = $('.fadein-image');
    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries, obs) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var $wrapper = $(entry.target);
                    // If there is an <img> child, wait for it to fully load
                    var $img = $wrapper.find('img[loading="lazy"]');
                    if ($img.length) {
                        if ($img[0].complete && $img[0].naturalHeight !== 0) {
                            $wrapper.addClass('is-loaded');
                        } else {
                            $img.on('load', function() {
                                $wrapper.addClass('is-loaded');
                            });
                        }
                    } else {
                        // For non-img fadein (e.g. background images)
                        $wrapper.addClass('is-loaded');
                    }
                    obs.unobserve(entry.target);
                }
            });
        }, { threshold: 0});

        $wrappers.each(function() {
            observer.observe(this);
        });
    } else {
        // Fallback for browsers without Intersection Observer: fade in on load
        $wrappers.each(function() {
            var $wrapper = $(this);
            var $img = $wrapper.find('img[loading="lazy"]');
            if ($img.length) {
                if ($img[0].complete && $img[0].naturalHeight !== 0) {
                    $wrapper.addClass('is-loaded');
                } else {
                    $img.on('load', function() {
                        $wrapper.addClass('is-loaded');
                    });
                }
            } else {
                $wrapper.addClass('is-loaded');
            }
        });
    }
}

$(initImageFadeIn);